module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"yLabel":"Scope 1-2 Emissionen* (kg CO₂e/m²)","xLabel":"Endenergie* (kWh/m²)","emissionsTooltip":"Scope 1-2 Emissionen*","emissionsUnitsTooltip":"kg CO₂e/m²","energyTooltip":"Endenergie*","energyUnitsTooltip":"kWh/m²","withoutTenantSideNote":"*Mieterseitige Energie und mieterseitige Emissionen werden hier nicht miteingerechnet."}}')
  delete Component.options._Ctor
}
